module.exports = __webpack_public_path__ + "static/assets/ea720590bfca2b818aa05f10a72cf5f2.svg";